import "../css/Gallery.css";

const images = [
  "https://images.pexels.com/photos/302899/pexels-photo-302899.jpeg",
  "https://images.pexels.com/photos/374885/pexels-photo-374885.jpeg",
  "https://images.pexels.com/photos/1833306/pexels-photo-1833306.jpeg",
  "https://images.pexels.com/photos/2074130/pexels-photo-2074130.jpeg",
  "https://images.pexels.com/photos/302894/pexels-photo-302894.jpeg",
  "https://images.pexels.com/photos/1552106/pexels-photo-1552106.jpeg",
  "https://images.pexels.com/photos/373639/pexels-photo-373639.jpeg",
  "https://images.pexels.com/photos/374888/pexels-photo-374888.jpeg",
];

const Gallery = () => {
  return (
    <main className="gallery">

      {/* HERO */}
      <section className="gallery-hero">
        <h1>Gallery</h1>
        <p>Moments captured inside Neo Café</p>
      </section>

      {/* GRID */}
      <section className="gallery-grid">
        {images.map((src, index) => (
          <div key={index} className="gallery-item">
            <img src={src} alt={`Gallery ${index}`} />
          </div>
        ))}
      </section>

      {/* TEXT BREAK */}
      <section className="gallery-text">
        <p>
          Every corner has a story.<br />
          Every table remembers a conversation.
        </p>
      </section>

    </main>
  );
};

export default Gallery;
